import { findParentNodeOfTypeClosestToPos } from '@atlaskit/editor-prosemirror/utils';
/**
 *
 * @returns true if should ignore event happens within bodiedSyncBlock node when offline
 */
export var shouldIgnoreDomEvent = function shouldIgnoreDomEvent(view, event, api) {
  var _api$connectivity, _view$posAtCoords;
  if ((api === null || api === void 0 || (_api$connectivity = api.connectivity) === null || _api$connectivity === void 0 || (_api$connectivity = _api$connectivity.sharedState.currentState()) === null || _api$connectivity === void 0 ? void 0 : _api$connectivity.mode) !== 'offline') {
    return;
  }
  var bodiedSyncBlock = view.state.schema.nodes.bodiedSyncBlock;
  var pos = (_view$posAtCoords = view.posAtCoords({
    left: event.clientX,
    top: event.clientY
  })) === null || _view$posAtCoords === void 0 ? void 0 : _view$posAtCoords.pos;
  if (pos === undefined) {
    return;
  }
  var $pos = view.state.doc.resolve(pos);
  var maybeNode = findParentNodeOfTypeClosestToPos($pos, bodiedSyncBlock);
  if (maybeNode) {
    return true;
  }
};